import React, { Component } from 'react';

import Header from './../Header';
import Core from './../../Core/Core';
import ErrorManager from './../../Core/ErrorManager';

class ErrorBoundary extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            hasError : (props.match != null && props.match.params.error != null),
            error : props.match != null ? decodeURIComponent(props.match.params.error) : null
        }

        if(window.location.href.indexOf("/login") == -1 && Core.Instance.user == null)
        {
            window.location.href="/login";
        }
        window.title = "W-F: Erreur";
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ 
            hasError: true,
            error : JSON.stringify({
                "error" : error,
                "info" : info
            })
        });
        ErrorManager.Instance.Handle(error);
      }

    render()
    {
        if(this.state.hasError)
        {
            return (
                <div>
                    <Header />
                    <div className="container">
                        <h1>Erreur</h1>
                        <div className="row">
                            <div className="col">
                                <p>Une erreur a eu lieu. Nous sommes désolés pour ce désagrément. Le problème a été signalé au développeur.</p>
                                <hr />
                                <blockquote className="blockquote">
                                    <p className="mb-0">Détails</p>
                                    <footer className="blockquote-footer">
                                        { this.state.error }
                                    </footer>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else return (
            <div>
                { this.props.children }
            </div>
        );
    }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/Components/Views/ErrorBoundary.js